export const PARKING_NEEDS_VALIDATION = 0
export const PARKING_VALIDATED = 1
export const PARKING_REJECTED = 2

const parkingStatus = [
  {
    id: 0,
    name: "Pending",
  },
  {
    id: 1,
    name: "Validated",
  },
  {
    id: 2,
    name: "Rejected",
  },
]

export default parkingStatus
